<template>
  <div>
    <Steps v-if="process">
      <Step :title="item.name"
            v-for="(item, index) in process.steps"
            :key="'step_' + index"
            status="process"
            :icon="item.approval_object === 'user' ? 'ios-person' : item.approval_object === 'group' ? 'ios-people' : 'ios-contacts'"
            v-html="getContentHtml(item)"
            :content="'审批对象：' + (item.approval_object === 'user' ? '用户' : item.approval_object === 'group' ? '用户组' : item.approval_object === 'auto' ? '自动获取' : '项目角色')"></Step>
    </Steps>
  </div>
</template>

<script>
export default {
  name: 'approval-steps',
  props: {
    process: {
      type: Object,
      default: function () {
        return null
      }
    },
    showDetail: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      content: '<b>test</b>'
    }
  },
  methods: {
    getContentHtml (item) {
      let icon = 'ios-contacts'
      let approvalObject = '项目角色'
      let tObject = '<div class="ivu-tag ivu-tag-blue ivu-tag-checked"><span class="ivu-tag-text">' + (item.user_tag ? item.user_tag : '') + '</span></div>'
      if (item.approval_object === 'user') {
        icon = 'ios-person'
        approvalObject = '用户'
        tObject = ''
        for (let v in item.users_name) {
          tObject += '<span class="ivu-tag ivu-tag-blue ivu-tag-checked"><span class="ivu-tag-text">' + item.users_name[v] + '</span></span>'
        }
      } else if (item.approval_object === 'group') {
        icon = 'ios-people'
        approvalObject = '用户组'
        tObject = '<div class="ivu-tag ivu-tag-blue ivu-tag-checked"><span class="ivu-tag-text">' + (item.user_group_name ? item.user_group_name : '') + '</span></div>'
      } else if (item.approval_object === 'auto') {
        icon = 'ios-person'
        approvalObject = '自动获取'
        tObject = '<div class="ivu-tag ivu-tag-blue ivu-tag-checked"><span class="ivu-tag-text">' + '系统自动获取' + '</span></div>'
      }
      return '<div class="ivu-steps-tail"><i></i></div>' +
        '<div class="ivu-steps-head"><div class="ivu-steps-head-inner"><span class="ivu-steps-icon ivu-icon ivu-icon-' + icon + '"></span></div></div>' +
        '<div class="ivu-steps-main">' +
        '<div class="ivu-steps-title">' + item.name + '</div>' +
        '<div class="ivu-steps-content">' +
        '<p>审批对象：' + approvalObject + '</p>' +
        (this.showDetail ? '<p>' + tObject + '</p>' : '') +
        '</div>' +
        '</div>'
    }
  }
}
</script>

<style scoped>

</style>
